import { Tabs, TabsProps } from "antd";
import { useMemo } from "react";
import { ImpoundForm } from "./ImpoundForm";
import { Distributions } from "./Distributions";
import { ActivityDetails } from "./ActivityDetails";
import { useFetchImpoundAccount } from "../hooks/useFetchImpoundAccount";
import { Loader } from "../../../../../../../../../components/Loader";

type TImpoundsTabs = {
  id: string | null;
  reloadData: () => void;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setId: React.Dispatch<React.SetStateAction<string | null>>;
  parentId?: string;
  payeesNumber: {
    primaryBuyerNumber: number;
    primarySellerNumber: number;
  };
  activeKey: string;
  isDistributionModalOpen: boolean;
  setIsDistributionModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ImpoundsTabs = ({
  id,
  reloadData,
  setIsOpen,
  setId,
  parentId,
  payeesNumber,
  activeKey,
  isDistributionModalOpen,
  setIsDistributionModalOpen
}: TImpoundsTabs) => {
  const { isLoading, impoundAccount: openedImpoundAccount } = useFetchImpoundAccount(id);

  const items: TabsProps["items"] = useMemo(
    () => [
      {
        key: "details",
        label: "Details",
        children: (
          <ImpoundForm
            impoundAccount={openedImpoundAccount}
            reloadData={reloadData}
            setIsOpen={setIsOpen}
            setId={setId}
            parentId={parentId}
          />
        )
      },
      {
        key: "paymentsFromImpound",
        label: "Payments From Impound",
        children: (
          <Distributions
            impoundAccount={openedImpoundAccount}
            payeesNumber={payeesNumber}
            setIsOpen={setIsOpen}
            setParentId={setId}
            isDistributionModalOpen={isDistributionModalOpen}
            setIsDistributionModalOpen={setIsDistributionModalOpen}
          />
        )
      },
      {
        key: "activitydetails",
        label: "Activity Details",
        children: (
          <ActivityDetails
            impoundAccount={openedImpoundAccount}
            parentId={parentId}
            setIsOpen={setIsOpen}
            setParentId={setId}
          />
        )
      }
    ],
    [
      openedImpoundAccount,
      reloadData,
      setIsOpen,
      setId,
      parentId,
      payeesNumber,
      isDistributionModalOpen,
      setIsDistributionModalOpen
    ]
  );

  return (
    <>
      {id !== null && isLoading ? (
        <Loader fontSize="64px" />
      ) : (
        <>
          {id !== null ? (
            <Tabs items={items} defaultActiveKey={activeKey || "details"} />
          ) : (
            <ImpoundForm
              impoundAccount={openedImpoundAccount}
              reloadData={reloadData}
              setIsOpen={setIsOpen}
              setId={setId}
              parentId={parentId}
            />
          )}
        </>
      )}
    </>
  );
};
